// extracted by mini-css-extract-plugin
export default {"overlay":"VideoPlayer--overlay--stWvA","playButton":"VideoPlayer--play-button--xZsLr"};